import React, { Component } from 'react'


class Contact extends Component {

    render() {
        return (
            <div className='columns'>
                <div className='column is-one-third'></div>
                <div className='column is-one-third'>
                    <div className='level is-mobile'>
                        <div className='level-item'>
                            <a className='button' href='mailto:ashley.kyle.smith@gmail.com?Subject=Hey!' target='_top'>
                                <span className='icon'><i className='far fa-envelope'></i></span>
                            </a>
                        </div>
                        <div className='level-item'>
                            <a className='button' href='https://www.linkedin.com/in/ashleykylesmith' target='_blank' rel='noopener noreferrer'>
                                <span className='icon'><i className='fab fa-linkedin'></i></span>
                            </a>
                        </div>
                        <div className='level-item'>
                            <a className='button' href='https://github.com/ksibod' target='_blank' rel='noopener noreferrer'>
                                <span className='icon'><i className='fab fa-github'></i></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='column is-one-third'></div>
            </div>
        )
    }

}


export default Contact



// WEBPACK FOOTER //
// ./src/components/contact.js